import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  progress: number;
}
export function ProgressBar({
  progress
}: ProgressBarProps) {
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50" data-id="element-79">
      <div className="max-w-md mx-auto px-4 py-2 flex items-center justify-between" data-id="element-80">
        <span className="text-xs font-medium text-gray-600" data-id="element-81">
          {progress}% Complete
        </span>
        <div className="flex-1 ml-4 h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-82">
          <motion.div className="h-full bg-teal-500" initial={{
          width: 0
        }} animate={{
          width: `${progress}%`
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} data-id="element-83" />
        </div>
      </div>
    </div>;
}